import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { login02, logo } from '../../imagepath';
import { APP_NAME } from '../../../constants/constants';
import { resetPassword } from '../../../api/auth.api';
import { translateError } from '../../../utils/errorTranslations';

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState(location.state?.email || '');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        // If no email was provided, redirect to forgot password
        if (!email) {
            navigate('/forgot-password');
        }
    }, [email, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validate passwords match
        if (newPassword !== confirmPassword) {
            setError('Паролите не съвпадат');
            return;
        }

        // Validate password length
        if (newPassword.length < 8) {
            setError('Паролата трябва да бъде поне 8 символа');
            return;
        }

        setIsLoading(true);

        try {
            await resetPassword({ email, code, newPassword });
            setSuccess(true);
            // Redirect to login after 3 seconds
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            // Extract and translate error message
            let errorMessage = 'Неуспешна смяна на паролата. Моля опитайте отново.';

            if (err?.data?.error) {
                errorMessage = translateError(err.data.error);
            } else if (err?.data?.message) {
                errorMessage = translateError(err.data.message);
            } else if (err?.status === 400) {
                errorMessage = 'Невалиден код за потвърждение. Моля проверете и опитайте отново.';
            } else if (err?.status === 500) {
                errorMessage = 'Сървърна грешка. Моля опитайте по-късно.';
            }

            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="main-wrapper login-body">
                <div className="container-fluid px-0">
                    <div className="row">
                        {/* Login logo */}
                        <div className="col-lg-6 login-wrap">
                            <div className="login-sec">
                                <div className="log-img">
                                    <img
                                        className="img-fluid"
                                        src={login02}
                                        alt="Logo"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* /Login logo */}
                        {/* Login Content */}
                        <div className="col-lg-6 login-wrap-bg">
                            <div className="login-wrapper">
                                <div className="loginbox">
                                    <div className="login-right">
                                        <div className="login-right-wrap">
                                            <div className="account-logo">
                                                <Link to="/login" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                                    <img src={logo} width="50" height="50" alt=""/>
                                                    <span style={{ marginLeft: '15px', fontSize: '28px', fontWeight: '500', color: '#2e37a4' }}>{APP_NAME}</span>
                                                </Link>
                                            </div>
                                            <h2>Смяна на парола</h2>
                                            <p style={{ marginBottom: '20px', color: '#6c757d' }}>
                                                Въведете кода за потвърждение, изпратен на {email}, и вашата нова парола.
                                            </p>

                                            {success && (
                                                <div className="alert alert-success" role="alert">
                                                    Паролата е успешно променена! Пренасочване към страницата за вход...
                                                </div>
                                            )}

                                            {error && (
                                                <div className="alert alert-danger" role="alert">
                                                    {error}
                                                </div>
                                            )}

                                            {/* Form */}
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-group">
                                                    <label>
                                                        Код за потвърждение <span className="login-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={code}
                                                        onChange={(e) => setCode(e.target.value)}
                                                        required
                                                        disabled={isLoading || success}
                                                        placeholder="123456"
                                                        maxLength="6"
                                                    />
                                                    <small className="form-text text-muted">
                                                        Проверете вашия имейл за 6-цифрения код
                                                    </small>
                                                </div>

                                                <div className="form-group">
                                                    <label>
                                                        Нова парола <span className="login-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="password"
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                        required
                                                        disabled={isLoading || success}
                                                        placeholder="Минимум 8 символа"
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>
                                                        Потвърдете паролата <span className="login-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="password"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        required
                                                        disabled={isLoading || success}
                                                        placeholder="Повторете новата парола"
                                                    />
                                                </div>

                                                <div className="form-group login-btn">
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        type="submit"
                                                        disabled={isLoading || success}
                                                    >
                                                        {isLoading ? 'Променяне...' : 'Промени парола'}
                                                    </button>
                                                </div>
                                            </form>
                                            {/* /Form */}
                                            <div className="next-sign">
                                                <p className="account-subtitle">
                                                    Не получихте код? <Link to="/forgot-password">Изпратете отново</Link>
                                                </p>
                                                <p className="account-subtitle">
                                                    <Link to="/login">Обратно към вход</Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Login Content */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;
